import React, { useEffect, useState } from 'react';
import { api } from './page'; // adjust import if needed
// import axios from 'axios';




function parseTeams(matchName) {
  const vsIndex = matchName.indexOf(' Vs ');
  if (vsIndex === -1) return ['TBD', 'TBD'];
  const [team1, rest] = [matchName.slice(0, vsIndex), matchName.slice(vsIndex + 4)];
  const team2 = rest.split(',')[0];
  return [team1.trim(), team2.trim()];
}

const WinnerSetter = () => {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [setting, setSetting] = useState(null);

  useEffect(() => {
    api.get('/wins')
      .then(res => setMatches(res.data))
      .catch(() => setError('Failed to fetch matches'))
      .finally(() => setLoading(false));
  }, []);

  const handleSetWinner = async (matchId, winnerTeam) => {
    setSetting(matchId);
    setError('');
    try {
      const res = await api.patch(`/${matchId}/winner`, { winner: winnerTeam });
      setMatches(prev =>
        prev.map(m => m.matchId === matchId ? res.data : m)
      );
    } catch (e) {
      setError('Failed to set winner');
    }
    setSetting(null);
  };

  if (loading) return <div>Loading matches...</div>;
  if (error) return <div style={{ color: 'red' }}>{error}</div>;

  return (
    <div style={{ marginTop: 24 }}>
      <h2>Set Match Winners</h2>
      {matches.map(match => {
        const [team1, team2] = parseTeams(match.matchName);
        return (
          <div key={match.matchId} style={{
            border: '1px solid #eee',
            borderRadius: 6,
            padding: 12,
            marginBottom: 12,
            background: '#fafafa'
          }}>
            <div>
              <strong>{team1}</strong> vs <strong>{team2}</strong>
              <span style={{ marginLeft: 12, color: '#888' }}>Match #{match.matchNo}</span>
            </div>
            <div>
              {match.winner ? (
                <span style={{ color: 'green', fontWeight: 'bold' }}>
                  Winner: {match.winner}
                </span>
              ) : (
                <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                  <button
                    disabled={setting === match.matchId}
                    onClick={() => handleSetWinner(match.matchId, team1)}
                  >
                    Set {team1} Winner
                  </button>
                  <button
                    disabled={setting === match.matchId}
                    onClick={() => handleSetWinner(match.matchId, team2)}
                  >
                    Set {team2} Winner
                  </button>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default WinnerSetter;